import React, { useEffect } from "react";
import { useParams, useNavigate ,Link} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchBlogs } from "../../slice/blogSlice";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { blogs = [], loading, error } = useSelector((state) => state.blog);

  useEffect(() => {
    if (!blogs || blogs.length === 0) {
      dispatch(fetchBlogs());
    }
  }, [dispatch, blogs]);

  const blog = blogs.find((item) => String(item._id || item.id) === String(id));

  if (loading) return <div className="p-6 text-center">Loading...</div>;
  if (error) return <div className="p-6 text-center text-red-500">Error: {error}</div>;
  if (!blog) return <div className="p-6 text-center text-gray-600">Blog not found.</div>;

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-10 bg-gray-100 min-h-screen">

      <div className="max-w-7xl mx-auto p-6 rounded-lg ">
 
        {/* Back Button at Top */}
     <div className="mb-6">
             <Link to="/blogs" className="text-sm text-[#345bf3] hover:underline">
               ← Back to Blogs
             </Link>
           </div>

        {/* Blog Image */}
        <div className="mb-6">
          <img
            src={`${process.env.REACT_APP_BACKEND_URL_REL}blogs/${blog.image}`}
            alt={blog.title}
            className="w-full max-h-[450px] object-cover rounded-lg"
          />
        </div>

        {/* Blog Title & Content */}
        <h1 className="text-3xl font-bold text-[#fc3c04] mb-4">{blog.title}</h1>
        <div className="text-gray-800 text-base text-justify leading-relaxed whitespace-pre-line">
          {blog.description}
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
